import { AdditionalRate } from 'src/app/recruiting/locums-margin-calculator/models/additional-rate.model';
import { AdditionalRateTypes } from 'src/app/recruiting/locums-margin-calculator/enums/additional-rate-types.enum';

const HOURS_24 = 24;
const HOURS_12 = 12;

const HOURS_DEFAULT: Partial<Record<AdditionalRateTypes, number | null>> = {
    [AdditionalRateTypes.ON_CALL_24HOURS]: HOURS_24,
    [AdditionalRateTypes.WEEKEND_CALL]: HOURS_24,
    [AdditionalRateTypes.NIGHT_SHIFT_CALL]: HOURS_12,
    [AdditionalRateTypes.CALL_BACK]: null
};

export function deriveHoursByAdditionalRate(rate: AdditionalRate): number {
    const expectedHours = rate.expectedHours ?? 0;
    const defaultDuration = HOURS_DEFAULT[rate.additionalRateTypeId];

    // For CALL_BACK, which has no default duration, use expectedHours directly
    if (rate.additionalRateTypeId === AdditionalRateTypes.CALL_BACK) {
        return expectedHours;
    }

    if (expectedHours > 0) {
        return expectedHours;
    }

    const shifts = Number(rate.expectedShifts ?? 0);

    if (shifts > 0) {
        return shifts * defaultDuration;
    }
    return 0;
}
